import { configure } from '@creditas/event-track'

const env = process.env.APP_ENV === 'production' ? 'production' : 'staging'

const eventTrackService = configure({
  application: 'insurance-offer-app',
  bu: 'IN',
  environment: env,
})

export { eventTrackService }
